import { DBFactory } from "~/classes/database/db_factory";

export const useCreateEvaluationTestWithParagraphs = async ({
  paragraphs,
  metricId,
  checklistCriteriaId,
  checklistId,
  checklistName,
  label,
}: {
  paragraphs: Paragraphs;
  metricId: string;
  checklistCriteriaId: string;
  checklistId: string;
  checklistName: string;
  label: string;
  label: string;
}) => {
  const response = await $fetch(`/api/sys-admin/test/create-test-document`, {
    method: "POST",
    headers: await useApiHeaders(),
    body: {
      paragraphs: paragraphs,
      checklistId: checklistId,
      checklistName: checklistName,
    },
  });

  if (
    response.documentId == undefined ||
    response.revisionId == undefined ||
    checklistCriteriaId == undefined
  ) {
    throw new Error("Failed to create test document");
  }

  var evaluationTest: EvaluationTest = {
    documentToTest: {
      path: `testDocuments/${response.documentId}/revisions/${response.revisionId}`,
      source: "path",
    },
    documentText: label,
    description: label,
    metricId: metricId,
    status: EvaluationTestStatus.requiresDeveloperReview,
    originalReportedProblem: {
      documentId: response.documentId,
      revisionId: response.revisionId,
      checklistId: checklistId,
      checklistName: checklistName,
      checklistCriteriaId: checklistCriteriaId,
      checklistCriteriaName: "",
      userId: "",
      userEmail: "",
      problem: {},
    },
    evaluationResult: {} as any,
    isControl: false,
    lastRunSuccess: false,
    jiraIdentifiers: [],
    tags: [],
    createdAtTimestamp: Date.now(),
    updatedTimestamp: Date.now(),
  };

  // OK so we want to save this to the evaluationTestRuns collection but we also want ot add it to this run.

  const db = DBFactory.createDatabase();
  const id = await db.save(evaluationTest, {
    path: `evaluationTests`,
    collection: "evaluationTests",
  });

  return id;
};
